var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9939 8.00771C12.7197 8.00771 9.6105 7.71645 8.42291 10.7643C7.93237 12.0231 8.00361 13.658 8.00361 15.9989C8.00361 18.053 7.93778 19.9836 8.42291 21.2325C9.60779 24.2822 12.7422 23.99 15.9921 23.99C19.1274 23.99 22.3601 24.3165 23.5621 21.2325C24.0536 19.9611 23.9814 18.3506 23.9814 15.9989C23.9814 12.8771 24.1537 10.8617 22.6396 9.34859C21.1067 7.81564 19.0336 8.00771 15.9903 8.00771H15.9939ZM15.2779 9.44778C22.1076 9.43696 22.9769 8.6777 22.4972 19.2253C22.3267 22.9557 19.4863 22.5464 15.9948 22.5464C9.62853 22.5464 9.44548 22.3642 9.44548 15.9953C9.44548 9.55238 9.95045 9.45139 15.2779 9.44598V9.44778ZM20.2591 10.7742C19.7297 10.7742 19.3005 11.2035 19.3005 11.7328C19.3005 12.2621 19.7297 12.6913 20.2591 12.6913C20.7884 12.6913 21.2176 12.2621 21.2176 11.7328C21.2176 11.2035 20.7884 10.7742 20.2591 10.7742ZM15.9939 11.8951C13.7278 11.8951 11.891 13.7328 11.891 15.9989C11.891 18.2649 13.7278 20.1018 15.9939 20.1018C18.2599 20.1018 20.0959 18.2649 20.0959 15.9989C20.0959 13.7328 18.2599 11.8951 15.9939 11.8951ZM15.9939 13.3352C19.5151 13.3352 19.5196 18.6626 15.9939 18.6626C12.4735 18.6626 12.4681 13.3352 15.9939 13.3352Z",
    fill: "#050823"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3ff5d2a57ba32745bc94cdcdfd48d09b.svg";
export { ForwardRef as ReactComponent };